import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { CoreService } from 'app/services/entidades/core.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class EventsService extends CoreService {

  constructor(
    private _http: Http
  ) {
    super(_http);
  }

  /**
   * Servicio para crear nuevos eventos/casos en el sistema
   * @param  {Object} event Datos del nuevo evento
   * @return {any}          JSON con respuesta del servidor
   */
  add(event: any): Observable<any> {
    return this.postMethod('events/create', event);
  }

  /**
   * Trae los datos del o los casos
   * @param  {number} id ID del caso
   * @return {any}       JSON con los datos del caso
   */
  get(idcaso: number = null): Observable<any> {
    if (idcaso) {
      return this.getMethod(`events/${idcaso}`);
    } else {
      return this.getMethod('events/index');
    }
  }

  getByCustomer(idcustomer: number): Observable<any> {
    return this.getMethod(`events/${idcustomer}/customer`);
  }

  getUsuarioCasoTrabajado(idcaso: number): Observable<any> {
    return this.getMethod(`events/${idcaso}/usuarios`);
  }

  /**
   * Guarda todos los cambios en un caso
   * @param  {object} event Datos del evento
   * @return {any}       JSON con la respuesta del servidor
   */
  edit(event: any): Observable<any> {
    return this.putMethod('events/', event);
  }

  delete(idcaso: number): Observable<any> {
    return this.deleteMethod(`events/${idcaso}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/entidades/events.service.ts